import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderItemsByOrderInput } from './GetOrderItemsByOrderInput';
import { GetOrderItemsByOrderOutput } from './GetOrderItemsByOrderOutput';

export class GetOrderItemsByOrderService extends HttpServiceBase {

  handle = (input: GetOrderItemsByOrderInput): Promise<Result<GetOrderItemsByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetOrderItemsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/items`);
    return promise;
  }
}